import { onScopeDispose, type MaybeRefOrGetter } from 'vue';

import { seoController, type SeoController } from './controller';
import type { TitleNotification } from './types';

/** @public */
const useTitleNotification = (
  notification: MaybeRefOrGetter<TitleNotification | null>,
  controller: SeoController = seoController,
): void => {
  const dispose = controller.setTitleNotification(notification);
  onScopeDispose(dispose);
};

export { useTitleNotification };
